import { createRef, useEffect, useMemo, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useStoreContext } from 'store/app';
import OKSDK from '@odnoklassniki/ok-apps-sdk';
import cn from 'classnames';

import './styles/main.styl';
// import { Spinner } from 'components/core/spinner';
import { RouterProvider } from 'react-router';
import { router, routes } from 'utils/router';
import { Loading } from 'components/sections';
import { Toast } from 'components/core/Toast';
import { MainBgVideo } from 'components/sections/MainBgVideo';

const App = observer(() => {
    const {
        loaded,
        init,
        isMob,
        isNative,
        userState,
        catalogConfig,
        isCollectionFinished,
        isMainPartFinished,
        setShortLinkConfig,
        settings,
        isAnonym
    } = useStoreContext();
    const [inited, setInited] = useState(false);
    const [highRez, setHighRez] = useState(false);
    // const [showSpinner, setShowSpinner] = useState(false);

    const mainRef = createRef<HTMLDivElement>();
    // const timerRef = useRef<NodeJS.Timeout>();

    useEffect(() => {
        if (!inited) {
            setInited(true);
            OKSDK.init().then(() => init());
            if (isMob && !isNative) {
                document.querySelector('html')?.classList.add('rotation-hack');
            }
        }
    }, [inited]);

    // useEffect(() => {
    //     if (!loaded) {
    //         timerRef.current = setTimeout(() => {
    //             setShowSpinner(true);
    //         }, 2000);
    //     } else {
    //         timerRef.current && clearTimeout(timerRef.current);
    //         setShowSpinner(false);
    //     }
    // }, [loaded]);

    useEffect(() => {
        if (mainRef.current && mainRef.current.clientWidth > 720) {
            setHighRez(true);
        }
    }, [mainRef.current]);

    const component = useMemo(() => {
        if (!loaded) {
            return <Loading />;
        }

        const doPrepare = () => {
            if (isAnonym) {
                setShortLinkConfig();
                router.navigate(routes.welcome);
                return;
            }

            if (!userState || !catalogConfig) {
                router.navigate(routes.error);
                return;
            }

            const isFirstRun = userState.opened_lootboxes < 1;
            if (isFirstRun) {
                setShortLinkConfig();

                settings.hideOnboarding
                    ? router.navigate(routes.lootbox, { state: { isWelcomeFlow: true } })
                    : router.navigate(routes.welcome);
                return;
            }

            const hasOpenedBox = userState.current_lutbox_snakes && userState.current_lutbox_snakes.length > 0;
            const canOpenDailyBox =
                !userState.lootbox_open_days || !userState.lootbox_open_days.includes(userState.day);
            if (!isCollectionFinished && !isMainPartFinished && (hasOpenedBox || canOpenDailyBox)) {
                setShortLinkConfig();
                router.navigate(routes.lootbox);
                return;
            }

            router.navigate(routes.main);
        };

        doPrepare();
        return <RouterProvider router={router} />;
    }, [loaded]);

    return (
        <div
            ref={mainRef}
            className={cn('app', { mobile: isMob, web: !isMob, highRez, native: isNative })}
            id="snakesApp2024"
        >
            <MainBgVideo />
            {component}
            {<Toast />}
        </div>
    );
});

export default App;
